import React from 'react';
import logo from '../../assets/Images/LogoSpectra.png';
import { useNavigate } from "react-router-dom";



const Navbar = () => {
    const userName = sessionStorage.getItem("userName");
    const navigate = useNavigate();

    // const handleNavigate = () => {
    //     navigate("/users/admin");
    // }


    return (
        <>
            <div className="container-fluid Header-style text-light header ">
                <div className="d-flex align-items-center" style={{ padding: "2px" }}>
                    <button className="btn float-start" data-bs-toggle="offcanvas" href="#offcanvasExample" aria-controls="offcanvasExample" style={{ padding: "13px" }}>
                        <i className="fa-solid fa-bars text-light" ></i>
                        {/* <i className="fa-solid fa-bars text-light" data-bs-toggle="offcanvas" data-bs-target="#offcanvas"></i> */}
                    </button>
                    {/* <span className=" p-4">Home</span> */}
                    <img alt='SpectraLogo' src={logo} style={{ width: "150px" }} />
                    {/* Admin span pushed to end */}
                    {/* {(userName == "manager1" || userName == "Manager1") &&
                        <span className="admin-access ms-auto border p-1 rounded" onClick={handleNavigate}>
                            <i class="fa-solid fa-user"></i>
                            </span>
                    } */}
                </div>
            </div>
        </>
    )
}

export default Navbar
